<template>
  <div>
    <nav-breadcrumb :menu="[{label: '意向客户详情'}]"/>
    <el-row>
      <el-steps :active="6" class="step-shenpi">
        <el-step :title="'提交授信 System '" :description = "$moment(detailData.c__createdDate).format('YYYY-MM-DD HH:mm:ss')">
          <i class="step-start" slot="icon"></i>
        </el-step>
        <el-step v-if="approvalListcount>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
          <i class="step-mid" slot="icon"></i>
        </el-step>
        <el-step v-if="approvalListcount>1" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName" :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
          <i class="step-mid" slot="icon"></i>
        </el-step>
        <el-step v-if="approvalListcount>2" :title="Status2CN(approvalList[2].a__approvalType)+approvalList[2].a__approverName" :description="$moment(approvalList[2].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[2].a__approvingStatus)" >
          <i class="step-mid" slot="icon"></i>
        </el-step>
        <el-step v-if="approvalListcount>3" :title="Status2CN(approvalList[3].a__approvalType)+approvalList[3].a__approverName" :description="$moment(approvalList[3].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[3].a__approvingStatus)" >
          <i class="step-mid" slot="icon"></i>
        </el-step>
        <el-step v-if="approvalListcount>4" :title="Status2CN(approvalList[4].a__approvalType)+approvalList[4].a__approverName" :description="$moment(approvalList[4].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[4].a__approvingStatus)" >
          <i class="step-mid" slot="icon"></i>
        </el-step>
        <el-step title="完成" v-if="detailData.c__applicationStatus == 'Approved'">
          <i class="step-over" slot="icon"></i>
        </el-step>
      </el-steps>
      <el-col class="grid-content bg-purple" @tab-click="handleClick">
        <el-row>
          <el-tabs v-model="tabName">
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <customer-detail-component v-model="detailData"/>
            </el-tab-pane>
            <el-tab-pane label="抵押车辆" name="ApplicationProcess">
              <customer-detail-vehicles-component v-model="detailData.vehicles"/>
            </el-tab-pane>
            <el-tab-pane label="审核意见" name="ApplicationStatus" v-if="detailData.c__applicationStatus == 'Rejected' ">
              <panel label="审核结果">
                <form-build-component
                  :form-data="item"
                  :form-columns="approvalFormColumns"
                  class="formTable"
                  v-for="(item,idx) in approvalList"
                  :key="idx"
                ></form-build-component>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="担保信息" name="guarantor" class="bg-purple">
              <customer-detail-guarantor-component v-model="detailData"/>
            </el-tab-pane>
            <el-tab-pane label="挂靠公司" name="ext-company" class="bg-purple">
              <customer-detail-ext-company-component v-model="detailData" />
            </el-tab-pane>
            <el-tab-pane label="授信信息" v-if="creditId!=''" name="credit" class="bg-purple">
              <panel>
                <data-table
                  :table-data="approvalArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
              <template>
                <div>
                  <el-form label-width="150px">
                    <el-row>
                      <panel title="授信信息" border>
                        <el-col :span="24">
                          <el-form-item label="贷款产品：">
                            {{creditForm.p__productName}}
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信类型：">
                            {{creditForm.cr__creditType}}
                          </el-form-item>
                          <el-form-item label="授信起始日：">
                            {{creditForm.cr__creditValidity1}}
                          </el-form-item>
                          <el-form-item label="贷款比例：">
                            {{creditForm.cr__financingRatio}} %
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信额度：">
                            {{creditForm.cr__lineOfCredit}}
                          </el-form-item>
                          <el-form-item label="授信到期日：">
                            {{creditForm.cr__creditValidity2}}
                          </el-form-item>
                          <el-form-item label="贷款阈值：">
                            {{creditForm.cr__threshold|formatMoney}} 元
                          </el-form-item>
                        </el-col>
                      </panel>
                    </el-row>
                  </el-form>
                </div>
              </template>
              <panel title="附件列表">
                <files-data-table :files.sync="files.files"></files-data-table>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="贷前风控" name="tongdun" class="bg-purple">
              <customer-tongdun-component v-model="detailData" :is-show-pic1="true"/>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <button-back/>
    </el-row>
  </div>
</template>

<script>
  import CustomerDetailComponent from '../../components/CustomerDetailComponent'
  import xhr from '../../../utils/xhr'
  import ButtonBack from '../../../components/ButtonBack'
  import Panel from '../../../components/Panel'
  import FormBuildComponent from "../../../components/FormBuild";
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import CustomerDetailVehiclesComponent from "../../components/CustomerDetailVehiclesComponent";
  import CustomerDetailGuarantorComponent from "../../components/CustomerDetailGuarantorComponent";
  import CustomerDetailExtCompanyComponent from "../../components/CustomerDetailExtCompanyComponent";
  import CustomerTongdunComponent from "../../components/CustomerTongdunComponent";
  export default {
    data() {
      return {
        tabName: 'CustomerSummary',
        creditId: this.$route.query['cr.creditId']||'',
        approvalListcount:0,
        detailData: {
          etcs: [],
          sinopecs: [],
          vehicles: [],
        },
        approvalArry:{
          data:[],
          count:0,
        },
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
        creditForm: {},
        files:{},
        formData: {
          c__applicationId: this.$route.query['c.applicationId'],
          a__approvingStatus: 'Rejected',
          a__remarks: ''
        },
        approvalFormColumns: [
          {
            label: '审核意见',
            field: 'a__approvingStatus',
            formatter: function (r,v) {
              return Status2CN(v)
            }
          },
          {
            label: '审核人',
            field: 'a__approverName'
          },
          {
            label: '审核时间',
            field: 'a__approvingDate',
            formatter: function(r,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            },
            span: 24,
          },
          {
            label: '审核备注',
            field: 'a__remarks',
            span: 24
          }
        ],
        approvalList: []
      }
    },
    components: {
      CustomerDetailExtCompanyComponent,
      CustomerDetailGuarantorComponent,
      CustomerDetailVehiclesComponent,
      FormBuildComponent,
      ButtonBack,
      CustomerDetailComponent,
      Panel,
      CustomerTongdunComponent
    },
    computed: {

    },
    mounted() {
      this.getApplyingCustomerDetail()
      this.getApplyingCustomerCreditAttachment
    },
    methods: {
      Status2CN,
      setApproval:function(){
        let arr=[]
        let count =2
        this.approvalArry.data.push(
          {
            node:'提交授信',
            approverName:'System',
            time:this.detailData.c__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )

        for(var i=0;i<this.approvalList.length;i++){
          let name =this.approvalList[i].a__approvalType


          this.approvalArry.data.push(
            {
              node:name,
              approverName:this.approvalList[i].a__approverName,
              time:this.approvalList[i].a__approvingDate,
              status:Status2CN(this.approvalList[i].a__approvingStatus),
              remarks:this.approvalList[i].a__remarks,

            }
          )
          count++


        }
        this.approvalArry.count = count
        console.log(this.approvalArry)
      },
      getApplyingCustomerCreditAttachment:function(){
        xhr.getApplyingCustomerCreditAttachment({
          'c.applicationId': this.$route.query['c.applicationId']
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.files = res.data.data
            }
          }catch(e){}
        })
      },

      getApplyingCustomerDetail: function () {
        xhr.getApplyingCustomerDetail({
          'c.applicationId': this.$route.query['c.applicationId']
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.detailData = res.data.data
              if(this.creditId){
                this.tabName = 'credit'
              }
              this.getApplyCustomerCreditDetail(this.creditId)
              this.getCustomerApprovalList()
            }
          }catch(e){}
        })
      },
      handleClick: function () {

      },
      getCustomerApprovalList: function() {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': this.$route.query['c.applicationId'],
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalList = res.data.data
                this.approvalListcount = res.data.count
                this.setApproval()
              }
            }catch (e) {

            }
          }
        )
      },
      getApplyCustomerCreditDetail: function (creditId) {
        xhr.getApplyCustomerCreditDetail({
            'cr.creditId': creditId
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                res.data.data.cr__creditValidity = [
                  res.data.data.cr__creditValidity1,
                  res.data.data.cr__creditValidity2
                ]
                this.creditForm = res.data.data
              }
            }catch (e) {

            }
          })
      },
      updateApproveCustomer: function (approvingStatus) {
        this.formData.a__approvingStatus = approvingStatus

        this.$confirm('确认该操作？').then(()=>{
          xhr.updateApproveCustomer(this.formData, res=>{
            try{
              if(res.data.status == 'success') {
                this.$alert('操作成功！')
                this.$router.back()
              }
            }catch (e) {
            }
          })
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingDetail.vue